import { useTranslation } from 'react-i18next';
import { Dialog, Spinner } from '@platform/ui';
import { cx } from '@platform/core/lib/cx';
import type { IAdvancedSearchProps } from './IAdvancedSearchProps';
import './lookupSearch.css';

/**
 * Розширений пошук для великих таблиць (UIUX/controls/lookup; прототип lkAdv): вікно до 960px і 86vh, у шапці — заголовок із
 * лічильником, поле пошуку-пігулка 40px з автофокусом і кругле ×; під шапкою — чипи модулів; липкий рядок заголовків на --surface2;
 * рядки 10px 18px, наведення --accent-soft, клік вибирає; «Збігів немає.». Esc, тло й × закривають (Dialog).
 */
export function AdvancedSearchDialog({ title, count, query, onQuery, columns, template, rows, chips, loading, onClose }: IAdvancedSearchProps) {
  const { t } = useTranslation();
  const search = (
    <label className="lkadv__search">
      <input autoFocus value={query} placeholder={t('fieldControls.search')} aria-label={t('app.search')} onChange={(e) => onQuery(e.target.value)} />
    </label>
  );
  return (
    <Dialog title={title} subtitle={count} actions={search} size="lg" onClose={onClose}>
      <div className="lkadv">
        {chips && <div className="lkadv__chips">{chips}</div>}
        <div className="lkadv__table" role="grid" aria-label={title}>
          <div className="lkadv__row lkadv__row--head" role="row" style={{ gridTemplateColumns: template }}>
            {columns.map((c) => <span key={c} role="columnheader">{c}</span>)}
          </div>
          {rows.map((r) => (
            <div key={r.key} className="lkadv__row" role="row" tabIndex={0} style={{ gridTemplateColumns: template }}
              onClick={r.onPick} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); r.onPick(); } }}>
              {r.cells.map((c, i) => (
                <span key={i} role="gridcell" className={cx('lkadv__cell', c.strong && 'is-strong', c.medium && 'is-medium', c.muted && 'is-muted', c.mono && 'is-mono')} title={c.text}>
                  {c.dot && <span className="dot" style={{ background: c.dot }} />}{c.node ?? c.text}
                </span>
              ))}
            </div>
          ))}
          {loading && !rows.length && <div className="lkadv__empty"><Spinner /></div>}
          {!loading && !rows.length && <div className="lkadv__empty">{t('fieldControls.nothingMatches')}</div>}
        </div>
      </div>
    </Dialog>
  );
}
